module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table-run', {
    staticClass: "no-search-table no-selectable-table table-custom-options",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": false,
      "include-settings": false,
      "include-delete-single": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("statusName")(props.row.status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.cancelDate, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.warehouse.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right pr-2 options-column options-column-transfers",
          class: {
            'active': props.row.classActive
          }
        }, [_c('span', {
          staticClass: "options-item"
        }, [_c('v-icon', {
          staticClass: "settings-icon material-icons icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.openDialog(props.row)
            }
          }
        }, [_vm._v("list")])], 1), _vm._v(" "), _c('div', {
          staticClass: "undo-item"
        }, [(props.row.showUndo) ? _c('v-icon', {
          staticClass: "undo-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.setDialogState(props.row.id, true)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\tundo\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
          attrs: {
            "width": "351"
          },
          model: {
            value: (props.row.dialog),
            callback: function($$v) {
              props.row.dialog = $$v
            },
            expression: "props.row.dialog"
          }
        }, [_c('v-card', [_c('v-card-title', {
          staticClass: "headline pb-0"
        }, [_vm._v("¿Está seguro de anular la transacción #" + _vm._s(props.row.number) + "?")]), _vm._v(" "), _c('v-card-text', {
          staticClass: "pt-0"
        }, [_vm._v("*Este proceso es irreversible")]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "pb-3"
        }, [_c('v-btn', {
          staticClass: "btn-save mr-2",
          nativeOn: {
            "click": function($event) {
              _vm.setDialogState(props.row.id, false)
            }
          }
        }, [_vm._v("No anular")]), _vm._v(" "), _c('v-btn', {
          staticClass: "btn-cancel ml-2",
          nativeOn: {
            "click": function($event) {
              _vm.undoTransfer(props.row)
            }
          }
        }, [_vm._v("Anular")])], 1)], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages),
      expression: "totalPages"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "700"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "pb-4 px-3"
  }, [(_vm.transferSelected) ? _c('v-card-title', {
    staticClass: "headline px-0"
  }, [_vm._v("\n\t\t\t\tLa transferencia #" + _vm._s(_vm.transferSelected.number) + " se realizó en la fecha " + _vm._s(_vm._f("parseDate")(_vm.transferSelected.createdAt)) + "\n\t\t\t\tal minibar: " + _vm._s(_vm.transferSelected.warehouse.name) + "\n\t\t\t\t"), _c('v-icon', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), (_vm.transferSelected.cancelDate) ? _c('span', [_vm._v("\n\t\t\t\t\tTransferencia anulada el día " + _vm._s(_vm._f("parseDate")(_vm.transferSelected.cancelDate)) + "\n\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('list-of-details', {
    attrs: {
      "columns": _vm.columnsToDetails,
      "rows": _vm.modalData
    },
    on: {
      "sortable-list-detail": _vm.sortableDetail,
      "search-list-detail": _vm.searchOnDetail
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52fa6bc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/transfers/List.vue
// module id = 1636
// module chunks = 52